import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function MobileCta() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > window.innerHeight * 0.8;
      const nearContact = document.querySelector("#contact")?.getBoundingClientRect().top < window.innerHeight * 0.6;
      setShow(past && !nearContact);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="md:hidden fixed bottom-0 left-0 right-0 z-40 p-4 bg-obsidian/90 backdrop-blur-xl border-t gold-border-subtle"
          data-testid="mobile-sticky-cta"
        >
          <button
            data-testid="mobile-sticky-cta-btn"
            onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
            className="w-full flex items-center justify-center gap-2 py-3.5 rounded-full bg-gold text-obsidian font-sans font-semibold text-sm tracking-wide"
          >
            Request a Proposal <ArrowUpRight size={16} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
